import { createFileRoute } from "@tanstack/react-router";
import { SpendPage } from "../features/spend/SpendPage";

export const Route = createFileRoute("/w/$ws/spend")({
  component: SpendPage,
});
